export default __webpack_public_path__ + "static/metamask-266ca179c75c51d62a6d3f72e28bba02.png";